/**
 * On every page load: syncs audience from resource metafield (custom.audience or custom.site_type)
 * into localStorage. Also writes minisite (factory54 / skims / lululemon) with no redirects.
 * Redirects neutral entry pages (e.g. /) using the stored audience preference.
 * Config: window.themeAudience (snippets/audience-preference.liquid).
 */
(function () {
  var config = window.themeAudience;
  if (!config || config.enabled === false) {
    return;
  }

  var STORAGE_KEY = config.storageKey || "factory54:audience";
  var MINISITE_STORAGE_KEY = config.minisiteStorageKey || "factory54:minisite";
  var VALID = {
    women: true,
    men: true,
    beauty: true,
  };
  var VALID_MINISITES = {
    factory54: true,
    skims: true,
    lululemon: true,
  };

  function normalizePath(pathname) {
    var path = (pathname || "/").toLowerCase();
    if (path.length > 1 && path.charAt(path.length - 1) === "/") {
      path = path.slice(0, -1);
    }
    return path;
  }

  function detectAudienceFromMetafield() {
    var value = (config.pageAudience || "").toLowerCase();
    return VALID[value] ? value : null;
  }

  function getStoredAudience() {
    try {
      var value = localStorage.getItem(STORAGE_KEY);
      return VALID[value] ? value : null;
    } catch (error) {
      return null;
    }
  }

  function setStoredAudience(audience) {
    if (!VALID[audience]) {
      return;
    }
    try {
      localStorage.setItem(STORAGE_KEY, audience);
    } catch (error) {
      /* private mode / blocked storage */
    }
  }

  function syncAudienceFromMetafield() {
    var detected = detectAudienceFromMetafield();

    if (detected) {
      setStoredAudience(detected);
    }

    return detected;
  }

  function detectMinisiteFromMetafield() {
    var value = (config.pageMinisite || "").toLowerCase();
    return VALID_MINISITES[value] ? value : null;
  }

  function getStoredMinisite() {
    try {
      var value = localStorage.getItem(MINISITE_STORAGE_KEY);
      return VALID_MINISITES[value] ? value : null;
    } catch (error) {
      return null;
    }
  }

  function setStoredMinisite(minisite) {
    if (!VALID_MINISITES[minisite]) {
      return;
    }
    try {
      localStorage.setItem(MINISITE_STORAGE_KEY, minisite);
    } catch (error) {
      /* private mode / blocked storage */
    }
  }

  function syncMinisiteFromMetafield() {
    var detected = detectMinisiteFromMetafield();

    if (detected) {
      setStoredMinisite(detected);
    }

    return detected;
  }

  function isExcludedPath(pathname) {
    var path = normalizePath(pathname);
    var prefixes = config.excludedPathPrefixes || [];
    for (var i = 0; i < prefixes.length; i++) {
      var prefix = prefixes[i];
      if (path === prefix || path.indexOf(prefix + "/") === 0) {
        return true;
      }
    }
    return false;
  }

  function shouldRedirectFrom(pathname) {
    var path = normalizePath(pathname);
    var roots = config.redirectFromPaths || ["/"];
    for (var i = 0; i < roots.length; i++) {
      if (path === normalizePath(roots[i])) {
        return true;
      }
    }
    return false;
  }

  function getHomeUrl(audience) {
    if (audience === "women") {
      return config.womenHomeUrl || config.rootUrl || "/";
    }
    if (audience === "men") {
      return config.menHomeUrl || null;
    }
    if (audience === "beauty") {
      return config.beautyHomeUrl || null;
    }
    return null;
  }

  function rewriteAudienceHomeLinks() {
    var audience = getStoredAudience();
    if (!audience) {
      return;
    }

    var target = getHomeUrl(audience);
    if (!target) {
      return;
    }

    document
      .querySelectorAll("[data-audience-home-link]")
      .forEach(function (link) {
        link.setAttribute("href", target);
      });
  }

  function rewriteVendorLinks() {
    var audience = getStoredAudience();

    document
      .querySelectorAll("a.vendor[data-vendor-url-w]")
      .forEach(function (link) {
        var url =
          link.getAttribute("data-vendor-url-default") ||
          link.getAttribute("href");

        if (audience === "women") {
          url = link.getAttribute("data-vendor-url-w") || url;
        } else if (audience === "men") {
          url = link.getAttribute("data-vendor-url-m") || url;
        } else if (audience === "beauty") {
          url = link.getAttribute("data-vendor-url-b") || url;
        }

        link.setAttribute("href", url);
      });
  }

  function rewriteAudienceCollectionGrids() {
    var audience = getStoredAudience() || "women";
    var grids = document.querySelectorAll("[data-audience-collection-grid]");

    grids.forEach(function (grid) {
      var items = grid.querySelectorAll(".col_item");
      if (!items.length) {
        return;
      }

      var limit = parseInt(grid.getAttribute("data-audience-limit") || "4", 10);
      if (!Number.isFinite(limit) || limit < 1) {
        limit = 4;
      }

      var shown = 0;

      items.forEach(function (item) {
        var itemAudience = (
          item.getAttribute("data-audience") || ""
        ).toLowerCase();
        var matches = !itemAudience || itemAudience === audience;

        if (matches && shown < limit) {
          item.hidden = false;
          shown += 1;
        } else {
          item.hidden = true;
        }
      });

      if (shown === 0) {
        items.forEach(function (item, index) {
          item.hidden = index >= limit;
        });
      }

      grid.classList.add("is-ready");
    });
  }

  function updateHeaderNavCurrent() {
    var nav = document.querySelector(".header__drawer-inline-nav");
    if (!nav) {
      return;
    }

    var minisite = getStoredMinisite();
    var audience = getStoredAudience();
    var links = nav.querySelectorAll("a.header__drawer-panel-trigger");

    links.forEach(function (link) {
      var audienceNav = (
        link.getAttribute("data-audience-nav") || ""
      ).toLowerCase();
      var minisiteNav = (
        link.getAttribute("data-minisite-nav") || ""
      ).toLowerCase();
      var isCurrent = false;

      if (minisite === "lululemon" || minisite === "skims") {
        isCurrent = minisiteNav === minisite;
      } else if (audienceNav) {
        isCurrent = audienceNav === (audience || "women");
      }

      if (isCurrent) {
        link.setAttribute("aria-current", "page");
      } else if (audienceNav || minisiteNav) {
        link.removeAttribute("aria-current");
      }
    });
  }

  function rewriteAudienceLinks() {
    rewriteAudienceHomeLinks();
    rewriteVendorLinks();
  }

  function applyAudienceOnPageLoad() {
    rewriteAudienceLinks();
    rewriteAudienceCollectionGrids();
    if (pendingHomeRedirect) {
      var nav = document.querySelector(".header__drawer-inline-nav");
      if (nav) {
        nav
          .querySelectorAll("a.header__drawer-panel-trigger[aria-current]")
          .forEach(function (link) {
            link.removeAttribute("aria-current");
          });
      }
      return;
    }
    updateHeaderNavCurrent();
  }

  function bindAudienceNavLinks() {
    document.addEventListener(
      "click",
      function (event) {
        var link = event.target.closest("[data-audience-nav]");
        if (!link) {
          return;
        }

        var audience = (
          link.getAttribute("data-audience-nav") || ""
        ).toLowerCase();
        if (VALID[audience]) {
          setStoredAudience(audience);
          setStoredMinisite("factory54");
          rewriteAudienceLinks();
        }
      },
      true,
    );
  }

  function initAudienceHomeLinks() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", applyAudienceOnPageLoad);
    } else {
      applyAudienceOnPageLoad();
    }
  }

  function maybeRedirectFromHome() {
    var path = window.location.pathname;

    if (isExcludedPath(path)) {
      return false;
    }

    var audience = getStoredAudience();

    if (!audience || !shouldRedirectFrom(path)) {
      return false;
    }

    var target = getHomeUrl(audience);

    if (target && normalizePath(target) !== normalizePath(path)) {
      window.location.replace(
        target + window.location.search + window.location.hash,
      );
      return true;
    }

    return false;
  }

  syncAudienceFromMetafield();
  syncMinisiteFromMetafield();
  var pendingHomeRedirect = maybeRedirectFromHome();
  bindAudienceNavLinks();
  initAudienceHomeLinks();

  window.addEventListener("pageshow", function () {
    syncAudienceFromMetafield();
    syncMinisiteFromMetafield();
    applyAudienceOnPageLoad();
  });

  document.addEventListener(
    "cart-drawer:refreshed",
    rewriteAudienceCollectionGrids,
  );
  document.addEventListener(
    "shopify:section:load",
    rewriteAudienceCollectionGrids,
  );

  window.themeAudienceApi = {
    get: getStoredAudience,
    set: function (audience) {
      setStoredAudience(audience);
      if (VALID[audience]) {
        setStoredMinisite("factory54");
      }
      rewriteAudienceLinks();
    },
    getMinisite: getStoredMinisite,
    setMinisite: setStoredMinisite,
    syncFromMetafield: syncAudienceFromMetafield,
    syncMinisiteFromMetafield: syncMinisiteFromMetafield,
    detectFromMetafield: detectAudienceFromMetafield,
    detectMinisiteFromMetafield: detectMinisiteFromMetafield,
    getHomeUrl: getHomeUrl,
    rewriteHomeLinks: rewriteAudienceHomeLinks,
    rewriteVendorLinks: rewriteVendorLinks,
    rewriteCollectionGrids: rewriteAudienceCollectionGrids,
  };
})();
